/* Gridline — shared behaviours (vanilla, no frameworks)
   - drawer open/close: [data-drawer-open="Id"] toggles #Id (.dc-drawer)
   - ajax add-to-cart: form[data-ajax-cart] posts to /cart/add.js, updates [data-cart-count]
   - predictive search: [data-predictive-search] inputs query /search/suggest.json
   - recently viewed: window.DCRecentlyViewed (localStorage, capped at 12)
*/
(function () {
  'use strict';

  /* ---------- Drawers ---------- */
  var lastTrigger = null;

  function openDrawer(id, trigger) {
    var d = document.getElementById(id);
    if (!d) return;
    lastTrigger = trigger || null;
    d.setAttribute('data-open', '');
    document.documentElement.style.overflow = 'hidden';
    var focusable = d.querySelector('input, button, a, select, [tabindex]');
    if (focusable) focusable.focus();
  }

  function closeDrawer(d) {
    d.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'), opener);
      return;
    }
    var closer = e.target.closest('[data-drawer-close], .dc-drawer__scrim');
    if (closer) {
      var d = closer.closest('.dc-drawer');
      if (d) closeDrawer(d);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.dc-drawer[data-open]');
    if (open) closeDrawer(open);
  });

  /* ---------- Ajax add to cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute('data-empty', count === 0);
    });
  }

  /* Post-add confirmation toast — listens to dc:cart:add */
  function showCartToast(item) {
    var existing = document.querySelector('.dc-cart-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'dc-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    var img = item && item.image
      ? '<img class="dc-cart-toast__thumb" src="' + String(item.image).replace(/(\.[a-z]{3,4})(\?|$)/i, '_128x$1$2') + '" alt="" width="48" height="48">'
      : '';
    var title = item && (item.product_title || item.title) ? (item.product_title || item.title) : 'Item';
    toast.innerHTML =
      img +
      '<div class="dc-cart-toast__body">' +
      '<strong>Added to cart</strong>' +
      '<span class="dc-cart-toast__title"></span>' +
      '</div>' +
      '<a class="dc-btn dc-btn--outline dc-cart-toast__btn" href="/cart">View cart</a>' +
      '<a class="dc-btn dc-btn--primary dc-cart-toast__btn" href="/checkout">Checkout</a>' +
      '<button type="button" class="dc-cart-toast__close" aria-label="Dismiss">&times;</button>';
    toast.querySelector('.dc-cart-toast__title').textContent = title;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    var hideTimer;
    function scheduleHide() { hideTimer = setTimeout(remove, 6000); }
    function remove() {
      clearTimeout(hideTimer);
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.remove(); }, 300);
    }
    toast.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
    toast.addEventListener('mouseleave', scheduleHide);
    toast.addEventListener('touchstart', function () { clearTimeout(hideTimer); }, { passive: true });
    toast.querySelector('.dc-cart-toast__close').addEventListener('click', remove);
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { remove(); document.removeEventListener('keydown', esc); }
    });
    scheduleHide();
  }

  document.addEventListener('dc:cart:add', function (e) {
    showCartToast(e.detail || {});
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var errEl = form.querySelector('[data-cart-error]');
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); }

    var fd = new FormData(form);
    var addedQty = parseInt(fd.get('quantity'), 10) || 1;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || 'error');
        // cart/add.js "quantity" is the merged line total, not the amount just added
        document.dispatchEvent(new CustomEvent('dc:cart:add', { detail: Object.assign({}, res.json, { added_quantity: addedQty }) }));
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (btn) {
          var orig = btn.textContent;
          btn.textContent = btn.getAttribute('data-added-label') || orig;
          setTimeout(function () { btn.textContent = orig; }, 1800);
        }
      })
      .catch(function (err) {
        if (errEl) { errEl.hidden = false; errEl.textContent = err.message; }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); }
      });
  });

  /* ---------- Predictive search ---------- */
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  document.querySelectorAll('[data-predictive-search]').forEach(function (wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var results = wrap.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    var close = function () { results.hidden = true; input.setAttribute('aria-expanded', 'false'); };

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,collection&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var res = data.resources.results;
          var html = '';
          if (res.products && res.products.length) {
            html += '<ul class="dc-psearch__list" role="listbox">';
            res.products.forEach(function (p) {
              html += '<li><a class="dc-psearch__item" href="' + p.url + '">';
              if (p.featured_image && p.featured_image.url) {
                html += '<img src="' + p.featured_image.url + '&width=80" width="40" height="40" alt="" loading="lazy">';
              }
              html += '<span class="dc-psearch__title">' + p.title + '</span>';
              if (p.price) html += '<span class="dc-psearch__price">' + p.price + '</span>';
              html += '</a></li>';
            });
            html += '</ul>';
          }
          if (res.collections && res.collections.length) {
            html += '<div class="dc-psearch__group">';
            res.collections.slice(0, 3).forEach(function (c) {
              html += '<a class="dc-chip" href="' + c.url + '">' + c.title + '</a>';
            });
            html += '</div>';
          }
          html += '<a class="dc-psearch__all" href="/search?q=' + encodeURIComponent(q) + '">' + (results.getAttribute('data-view-all-label') || 'View all results') + '</a>';
          if (!res.products || !res.products.length) {
            html = '<p class="dc-psearch__none">' + (results.getAttribute('data-none-label') || 'No matches') + '</p>' + html;
          }
          results.innerHTML = html;
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(close);
    }, 220);

    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (results.innerHTML) results.hidden = false; });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'dc:recently-viewed';
  window.DCRecentlyViewed = {
    record: function (item) {
      try {
        var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
        list = list.filter(function (x) { return x.handle !== item.handle; });
        list.unshift(item);
        localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
      } catch (e) { /* storage unavailable */ }
    },
    read: function (excludeHandle) {
      try {
        return JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (x) {
          return x.handle !== excludeHandle;
        });
      } catch (e) { return []; }
    }
  };
})();
